import * as React from 'react';
import { useTheme } from '@mui/system';
import {
  Typography,
  Divider,
  useMediaQuery
} from '@mui/material';
import { Tabs as BaseTabs } from '@mui/base/Tabs';
import { TabPanel as BaseTabPanel } from '@mui/base/TabPanel';
import { MenuItem } from './DonutMenu'
import Notifications from '@mui/icons-material/Notifications';
import ViewQuiltIcon from '@mui/icons-material/ViewQuilt';
import CommuteIcon from '@mui/icons-material/Commute';
import FmdBadIcon from '@mui/icons-material/FmdBad';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import DiscountIcon from '@mui/icons-material/Discount';
import IssueContent from './IssueContent'; // IssueContentをインポート
import { Tab, TabsList, TabsListMobile, TabPanel, Tabs } from './IssuesTabStyles'; // スタイルコンポーネントをインポート

export default function IssuesTab() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [selectedMenu, setSelectedMenu] = React.useState<string>('shops');
  const [tabValue, setTabValue] = React.useState(0);
  const menuItemHotel: MenuItem[] = [
    { id: 'shops', label: '', color: '#ff6b6b', icon: FmdBadIcon },
    { id: 'transportation', label: '', color: '#feca57', icon: CommuteIcon },
    { id: 'floor', label: '', color: '#48dbfb', icon: ViewQuiltIcon },
  ];
  const menuItemMall: MenuItem[] = [
    { id: 'shops', label: '', color: '#ff6b6b', icon: FmdBadIcon },
    { id: 'event', label: '', color: '#feca57', icon: Notifications },
    { id: 'floor', label: '', color: '#48dbfb', icon: ViewQuiltIcon },
  ];
  const MenuItemShop: MenuItem[] = [
    { id: 'goods', label: '', color: '#ff6b6b', icon: ShoppingCartIcon },
    { id: 'coupon', label: '', color: '#feca57', icon: DiscountIcon },
    { id: 'floor', label: '', color: '#48dbfb', icon: ViewQuiltIcon },
  ];
  interface TextItems {
    [key: string]: {
      [key: string]: {
        title: string;
        text: string;
      };
    };
  }
  const textItems: TextItems = {
    Hotel: {
      shops: {
        title: '周辺施設の案内',
        text: '周辺の飲食店や小売店の情報をリアルタイムに提供できます。<br />GoogleMapと連携し、開店中の店のみを表示することが可能です。<br />フロントでの対応業務を減らします。',
      },
      transportation: {
        title: '公共交通機関の案内',
        text: 'バス停の時刻表や駅までのルート案内などを提供します。<br />時刻表の張替え作業や地図の多言語対応の手間を減らします。<br />シャトルバスのリアルタイム案内にも活用できます。',
      },
      floor: {
        title: '館内案内',
        text: 'フロアガイドや館内設備の案内を提供します。<br />フロアガイド張替え工事やパンフレットの多言語対応の手間を減らします。<br />館内レストランの案内にも活用できます。',
      },
    },
    Mall: {
      shops: {
        title: 'ショップの案内',
        text: '施設内の飲食店や小売店の情報をリアルタイムに提供できます。<br />GoogleMapと連携し、開店中の店のみを表示することが可能です。<br />出店店舗の売上工場につながります。',
      },
      event: {
        title: 'イベントの案内',
        text: 'イベント情報やキャンペーン情報をリアルタイムに提供できます。<br />イベント対応のためのチラシ張り作業や案内業務を減らします。<br />デジタルスタンプラリーイベントなどの端末としても活用できます。',
      },
      floor: {
        title: 'フロアガイド',
        text: 'フロアガイドや施設の案内を提供します。<br />フロアガイド張替え工事やパンフレットの多言語対応の手間を減らします。<br />非常時の避難経路の案内にも活用できます。',
      },
    },
    Shop: {
      goods: {
        title: '商品情報の案内',
        text: '商品の詳細情報や在庫状況をリアルタイムに提供できます。<br />商品情報の更新作業や多言語対応の手間を減らします。<br />店頭での接客業務を効率化します。',
      },
      coupon: {
        title: 'クーポンの配布',
        text: 'クーポン情報をリアルタイムに提供できます。<br />クーポンの印刷や配布作業を減らします。<br />デジタルスタンプラリーイベントなどの端末としても活用できます。',
      },
      floor: {
        title: 'フロアガイド',
        text: 'フロアガイドや店舗の案内を提供します。<br />フロアガイド張替え工事やパンフレットの多言語対応の手間を減らします。<br />非常時の避難経路の案内にも活用できます。',
      },
    },
  };
  interface ImageItems {
    [key: string]: {
      [key: string]: {
        img: string;
        title: string;
        position: string;
      }[];
    };
  }
  const imageItems: ImageItems = {
    Hotel: {
      shops: [
        {
          img: '/images/Hotel/2.png',
          title: '2',
          position: 'right'
        },
        {
          img: '/images/Hotel/4.png',
          title: '4',
          position: 'center'
        },
        {
          img: '/images/Hotel/5.png',
          title: '5',
          position: 'right'
        }
      ],
      transportation: [
        {
          img: '/images/Hotel/1.png',
          title: '1',
          position: 'right'
        },
        {
          img: '/images/Hotel/6.png',
          title: '6',
          position: 'right'
        },
        {
          img: '/images/Hotel/3.png',
          title: '3',
          position: 'right'
        }
      ],
      floor: [
        {
          img: '/images/Hotel/7.png',
          title: '7',
          position: 'right'
        },
        {
          img: '/images/Hotel/8.png',
          title: '8',
          position: 'right'
        },
        {
          img: '/images/Hotel/9.png',
          title: '9',
          position: 'center'
        }
      ]
    },
    Mall: {
      shops: [
        {
          img: '/images/Mall/1.png',
          title: '1',
          position: 'right'
        },
        {
          img: '/images/Mall/2.png',
          title: '2',
          position: 'center'
        },
        {
          img: '/images/Mall/3.png',
          title: '3',
          position: 'right'
        }
      ],
      event: [
        {
          img: '/images/Mall/4.png',
          title: '4',
          position: 'right'
        },
        {
          img: '/images/Mall/5.png',
          title: '5',
          position: 'right'
        },
        {
          img: '/images/Mall/6.png',
          title: '6',
          position: 'right'
        }
      ],
      floor: [
        {
          img: '/images/Mall/7.png',
          title: '7',
          position: 'right'
        },
        {
          img: '/images/Mall/8.png',
          title: '8',
          position: 'right'
        },
        {
          img: '/images/Mall/9.png',
          title: '9',
          position: 'center'
        }
      ]
    },
    Shop: {
      goods: [
        {
          img: '/images/Shop/1.png',
          title: '1',
          position: 'right'
        },
        {
          img: '/images/Shop/2.png',
          title: '2',
          position: 'center'
        },
        {
          img: '/images/Shop/3.png',
          title: '3',
          position: 'right'
        }
      ],
      coupon: [
        {
          img: '/images/Shop/4.png',
          title: '4',
          position: 'right'
        },
        {
          img: '/images/Shop/5.png',
          title: '5',
          position: 'right'
        },
        {
          img: '/images/Shop/6.png',
          title: '6',
          position: 'right'
        }
      ],
      floor: [
        {
          img: '/images/Shop/7.png',
          title: '7',
          position: 'right'
        },
        {
          img: '/images/Shop/8.png',
          title: '8',
          position: 'right'
        },
        {
          img: '/images/Shop/9.png',
          title: '9',
          position: 'center'
        }
      ]
    }
  }
  const handleMenuClick = (id: string) => {
    setSelectedMenu(id as string);
  };

  const handleTabChange = (event: React.SyntheticEvent | null, newValue: number | string | null) => {
    if (newValue !== null) {
      setTabValue(newValue as number);
      // タブが切り替わったときにselectedMenuをリセット
      if (newValue === 0) { // 宿泊施設タブ
        setSelectedMenu('shops');
      } else if (newValue === 1) { // 商業施設タブ
        setSelectedMenu('shops');
      } else if (newValue === 2) { // 小売店タブ
        setSelectedMenu('goods');
      }
    }
  };

  return (
    <>
      {isMobile ? (
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          orientation="horizontal"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            width: '100%',
            height: '100%',
          }}
        >
          <TabsListMobile>
            <Tab>宿泊施設</Tab>
            <Tab>商業施設</Tab>
            <Tab>小売店</Tab>
          </TabsListMobile>
          <TabPanel value={0}>
            {tabValue === 0 &&
              <IssueContent
                type="Hotel"
                selectedMenu={selectedMenu}
                textItems={textItems}
                imageItems={imageItems}
                menuItems={menuItemHotel}
                handleMenuClick={handleMenuClick}
                isMobile={isMobile}
              />
            }
          </TabPanel>
          <TabPanel value={1}>
            {tabValue === 1 &&
              <IssueContent
                type="Mall"
                selectedMenu={selectedMenu}
                textItems={textItems}
                imageItems={imageItems}
                menuItems={menuItemMall}
                handleMenuClick={handleMenuClick}
                isMobile={isMobile}
              />
            }
          </TabPanel>
          <TabPanel value={2}>
            {tabValue === 2 &&
              <IssueContent
                type="Shop"
                selectedMenu={selectedMenu}
                textItems={textItems}
                imageItems={imageItems}
                menuItems={MenuItemShop}
                handleMenuClick={handleMenuClick}
                isMobile={isMobile}
              />
            }
          </TabPanel>
        </Tabs>
      ) : (
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          orientation="vertical"
          sx={{
            display: 'flex',
            gap: '16px',
            width: '100%',
            height: '100%',
          }}
        >
          <TabsList>
            <Tab>宿泊施設</Tab>
            <Tab>商業施設</Tab>
            <Tab>小売店</Tab>
          </TabsList>
          <TabPanel value={0}>
            {tabValue === 0 &&
              <IssueContent
                type="Hotel"
                selectedMenu={selectedMenu}
                textItems={textItems}
                imageItems={imageItems}
                menuItems={menuItemHotel}
                handleMenuClick={handleMenuClick}
                isMobile={isMobile}
              />
            }
          </TabPanel>
          <TabPanel value={1}>
            {tabValue === 1 &&
              <IssueContent
                type="Mall"
                selectedMenu={selectedMenu}
                textItems={textItems}
                imageItems={imageItems}
                menuItems={menuItemMall}
                handleMenuClick={handleMenuClick}
                isMobile={isMobile}
              />
            }
          </TabPanel>
          <TabPanel value={2}>
            {tabValue === 2 &&
              <IssueContent
                type="Shop"
                selectedMenu={selectedMenu}
                textItems={textItems}
                imageItems={imageItems}
                menuItems={MenuItemShop}
                handleMenuClick={handleMenuClick}
                isMobile={isMobile}
              />
            }
          </TabPanel>
        </Tabs>
      )}
    </>
  );
}
